export default __webpack_public_path__ + "static/paytio-comics-2460b2ba2f56e0ae6a129eaf508d215c.pdf";